import { object, string, number, boolean } from 'yup'
import { invalidMailAddress, mandatoryField } from '~shared/translations/yupSchemaErrors'

// todo extend of openapi request as soon as possible
export interface ExpectedRequest {
  courseName: string
  email: string
  phone: string
  attendeeName1: string
  attendeeName2?: string
  attendeeName3?: string
  attendeeName4?: string
}

export interface CourseRegistrationForm extends ExpectedRequest {
  agbAccepted: boolean
  streetAndNumber?: string
  zip?: string
  companyName?: string
  // city?: string
}

export const RegTrainingSchema = object<CourseRegistrationForm>({
  courseName: string().required(mandatoryField),
  companyName: string().required(mandatoryField),
  streetAndNumber: string().required(mandatoryField),
  zip: string().required(mandatoryField),
  phone: string().required(mandatoryField),
  email: string().email(invalidMailAddress).required(mandatoryField),
  agbAccepted: boolean().required(mandatoryField).oneOf([true], mandatoryField),
  attendeeName1: string().required(mandatoryField),
  attendeeName2: string(),
  attendeeName3: string(),
  attendeeName4: string(),
})
